import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import AgoraRTC, { AgoraRTCProvider } from "../../../lib/agora";
import type RootStackParamList from "../../../navigation/RootStackParamList";
import CallWebContainer from "./CallWebContainer";

type Props = NativeStackScreenProps<RootStackParamList, "Call">;

// Create a single Agora client instance for this screen. On web this is the
// agora-rtc-react client; on native it is the inert facade client (the real
// engine lives in the native facade — see src/lib/agora.native.ts).
const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

/**
 * Renders the call on every platform. AgoraRTCProvider + the call UI resolve to
 * the web SDK on web and react-native-agora on native via the agora facade.
 */
export default function CallContainer({ route, navigation }: Props) {
  const { room } = route.params;

  return (
    <AgoraRTCProvider client={client}>
      <CallWebContainer room={room} navigationReplace={navigation.replace} />
    </AgoraRTCProvider>
  );
}
